import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CapabilitiesFiltersProvider } from '@core/modules/capacities/data/providers';

export const validateFilterCapabilityGuard: CanActivateFn = () => {
  const filterProvider = inject(CapabilitiesFiltersProvider);
  const router = inject(Router);

  const isValid = filterProvider.formGroup.valid;

  if (!isValid) {
    return router.createUrlTree(['/capacity']);
  }

  return true;
};
